import "./App.css";
import ParticleCanvas from "./components/common/ParticleCanvas";
import AppRoutes from "./AppRoutes";
import "./assets/Script";
import { BrowserRouter, useLocation } from "react-router-dom";

const NotMyGirl = () => {
  const url = useLocation();
  console.log(url);
  if (!url.pathname.startsWith("/i/love/you/sakhi"))
    return (
      <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-black via-zinc-900 to-red-900 px-6">
        <div class="max-w-2xl text-center backdrop-blur-md bg-black/60 p-10 rounded-2xl shadow-2xl shadow-red-900/40">
          <p class="text-2xl md:text-3xl text-gray-300 italic mb-6 animate-fadeIn">
            I wish you could see this… but you’re no longer the one it was meant
            for.
          </p>

          <p class="text-3xl md:text-4xl font-bold text-red-500 drop-shadow-[0_0_15px_rgba(255,0,0,0.7)] tracking-wide">
            You were my love once.
            <span class="block mt-3">
              Now you’re just a memory I have to survive.
            </span>
          </p>
        </div>
      </div>
    );
};

function App() {
  return (
    <>
      <ParticleCanvas />
      <div id="floating-hearts-container"></div>
      <main className="main-container">
        <BrowserRouter>
          <NotMyGirl />
        </BrowserRouter>
        <AppRoutes />
      </main>
    </>
  );
}

export default App;
